import { useEffect, useState } from "react";
import { getWhatsAppEnabled } from "../services/whatsApp.service";

/**
 * Loads GET /api/WhatsApp/enabled once on mount (fail-closed → false).
 * Prefer folding getWhatsAppEnabled into an existing initial Promise.all
 * when the form must not become interactive until the probe finishes.
 */
export const useWhatsAppEnabled = (): boolean => {
  const [whatsAppEnabled, setWhatsAppEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getWhatsAppEnabled().then((enabled) => {
      if (!cancelled) {
        setWhatsAppEnabled(enabled);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return whatsAppEnabled;
};
